<lms-breadcrumb
  [crumbs]="[{ label: 'account.myAccount', route: '/accounts/my-account', icon: 'glicon-user-thin' }]"
  [inline]="true"
></lms-breadcrumb>
<ac-my-account></ac-my-account>
